import React, { FC } from 'react';
import { ArtistSubscriptionFragment } from '@minecraft.graphql-operations';
import { getDaysSinceTrialStarted } from '@blocs.features-experiments';
import { TrialProfileReadyBanner } from './TrialProfileReadyBanner';

/**
 * Show the profile-ready banner from the moment the trial starts until 10 full
 * days (240 hours) have elapsed. Day 10 begins only after 10 * 24 hours, matching
 * getDaysSinceTrialStarted (floor). After that, no global banner is shown.
 */
const TRIAL_PROFILE_READY_BANNER_DAYS = 10;

interface TrialGlobalBannerProps {
  subscription?: ArtistSubscriptionFragment;
  artistId?: string | number;
  profileUrl?: string;
}

export const TrialGlobalBanner: FC<TrialGlobalBannerProps> = ({ subscription, artistId, profileUrl }) => {
  if (!subscription || !artistId || !profileUrl) {
    return null;
  }

  const daysSinceTrialStarted = getDaysSinceTrialStarted(subscription);
  const isWithinBannerWindow =
    daysSinceTrialStarted !== undefined && daysSinceTrialStarted < TRIAL_PROFILE_READY_BANNER_DAYS;

  if (!isWithinBannerWindow) {
    return null;
  }

  return <TrialProfileReadyBanner profileUrl={profileUrl} />;
};
